import { useMemo } from 'react'
import { Autocomplete, Box, Grid, TextField, Typography } from '@mui/material'
import { useMediaQuery, useTheme } from '@mui/material'
import { useCropModalContext } from '../context/crop-modal-context'
import { DESKTOP_BREAKPOINT } from '~/common/constants/layout-constants'

export const CropCustomSpeciesRow = ({ cropFamilyTypes, cropArchetypes, filterFamilyOptions, handlers }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))
  const size = isDesktop ? 'medium' : 'small'

  const { customFamilyCode, archetype } = useCropModalContext()

  const selectedFamily = useMemo(
    () => cropFamilyTypes?.find(f => f.code === customFamilyCode) ?? null,
    [cropFamilyTypes, customFamilyCode]
  )

  return (
    <Grid
      container
      spacing="1rem"
      rowSpacing="0.5rem"
      sx={{ pt: '0.5rem' }}
    >
      <Grid size={{ xs: 12, sm: 6 }}>
        <Autocomplete
          size={size}
          disablePortal
          options={cropFamilyTypes ?? []}
          getOptionLabel={(opt) => opt?.name ?? ''}
          isOptionEqualToValue={(opt, val) => opt?.code === val?.code}
          filterOptions={filterFamilyOptions}
          value={selectedFamily}
          onChange={handlers.handleCustomFamilyChange}
          renderOption={({ key, ...props }, option) => (
            <li key={key} {...props}>
              <Box>
                <Typography variant="body2">{option.name}</Typography>
                <Typography variant="caption" color="text.secondary">{option.latin_name}</Typography>
              </Box>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Plant Family (optional)"
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Autocomplete
          size={size}
          disablePortal
          options={cropArchetypes ?? []}
          getOptionLabel={(opt) => opt?.label ?? ''}
          isOptionEqualToValue={(opt, val) => opt?.code === val?.code}
          value={archetype}
          onChange={handlers.handleCustomArchetypeChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Crop Type (optional)"
            />
          )}
        />
      </Grid>
    </Grid>
  )
}
